const LockIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_8461_7743"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="80"
      height="80"
    >
      <path
        d="M72 0H8C3.58172 0 0 3.58172 0 8V72C0 76.4183 3.58172 80 8 80H72C76.4183 80 80 76.4183 80 72V8C80 3.58172 76.4183 0 72 0Z"
        fill="#F4EFED"
      />
    </mask>
    <g mask="url(#mask0_8461_7743)">
      <path d="M80 0H0V80H80V0Z" fill="#0A0777" />
      <path
        d="M80 12H79.9873C79.6352 33.5733 70.755 53.0727 56.5664 67.2646C51.6401 72.1955 46.0719 76.4862 39.999 80C33.9282 76.4841 28.3599 72.1955 23.4316 67.2646C9.24711 53.0727 0.364922 33.5733 0.0126953 12H0V0H80V12Z"
        fill="#F4EFED"
      />
    </g>
    <path
      d="M53.0165 23.6398C53.0165 16.476 47.2077 10.667 40.0424 10.667C32.8771 10.667 27.0669 16.4746 27.0669 23.6398C27.0669 29.0909 30.4342 33.7493 35.1992 35.6678L27.7225 54.2384H52.3636L44.8869 35.6678C49.652 33.7479 53.0193 29.0909 53.0193 23.6398H53.0165Z"
      fill="#FB6E44"
    />
  </svg>
);

export default LockIcon;
